// Allows to upload names that will appear on the wheel.
import {useState} from 'react';
import '../styles/NameUploader.css';

type Props = {onNamesLoaded: (names: string[]) => void};

export default function NameUploader({onNamesLoaded}: Props) {
  const [text, setText] = useState('');
  const [isDragging, setIsDragging] = useState(false);

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const names = (reader.result as string).split(/\r?\n/).filter(Boolean);
      onNamesLoaded(names);
    };
    reader.readAsText(file);
  };

  const handleSubmit = () => {
    if (text.trim()) {
      onNamesLoaded(text.split('\n').filter(Boolean));
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        const names = (reader.result as string).split(/\r?\n/).filter(Boolean);
        onNamesLoaded(names);
      };
      reader.readAsText(file);
    }
  };

  return (
    <div className="name-uploader">
      <div className="text-input-container">
        <textarea 
          rows={6} 
          placeholder="Enter names, one per line"
          className="name-textarea" 
          value={text} 
          onChange={(e) => setText(e.target.value)} 
        />
        <button 
          className="submit-button"
          onClick={handleSubmit}
          disabled={!text.trim()}
        >
          Add Names
        </button>
      </div>
      
      <div 
        className={`file-drop-area ${isDragging ? 'dragging' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <p>Drop text file here</p>
        <p>or</p>
        <label className="file-upload-button">
          Choose File
          <input 
            type="file" 
            accept=".txt" 
            onChange={handleUpload} 
            className="hidden-input"
          />
        </label>
      </div>
    </div>
  );
}
